import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FooterService {
  private footerDataSource = new BehaviorSubject<any>(null);
  footerData$ = this.footerDataSource.asObservable();

  update(data: any) {
    this.footerDataSource.next(data);
  }

  clear() {
    this.footerDataSource.next(null);
  }
}
